/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolEggIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-egg"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 21.32Q12 21.32 10.47 21.32Q8.95 21.32 6.81 19.19Q4.67 17.05 4.67 14Q4.67 12.05 5.35 10.03Q6.03 8 7.08 6.38Q8.13 4.75 9.43 3.71Q10.72 2.67 12 2.67Q13.28 2.67 14.57 3.71Q15.88 4.75 16.93 6.38Q17.98 8 18.65 10.03Q19.32 12.05 19.32 14Q19.32 17.05 17.19 19.19Q15.05 21.32 12 21.32ZM12.63 17.88Q13.15 17.88 13.51 17.51Q13.88 17.15 13.88 16.63Q13.88 16.1 13.51 15.72Q13.15 15.35 12.63 15.35Q11.82 15.35 11.24 14.76Q10.65 14.18 10.65 13.38Q10.65 12.85 10.28 12.49Q9.9 12.13 9.38 12.13Q8.85 12.13 8.49 12.49Q8.13 12.85 8.13 13.38Q8.13 15.25 9.44 16.56Q10.75 17.88 12.63 17.88Z" fill={color} />
    </svg>
  );
}
